import React, { useState, useEffect } from 'react'
import Masonry from 'react-masonry-css'
import Banner from '../../Components/Banner'
import dishes from '../../Constants/dishes'
import { useTranslation  } from 'react-i18next';
interface Dish {
    id : number
    title : string
    description: string
    badge: string
    image: string
    category: string 
}

const cursorPointer = {
    cursor: "pointer"
}

function Restaurant() {
    
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function showBadge(badge:string) {
        if(badge!=='' && badge!==null)
            return <div className="knsl-badge">{badge}</div>
    }
        
        
    // function showPrice(price:number, promo:number) {
    //     if(promo>0)
    //         return <div className="knsl-price"><sup><span>{price}Xaf</span>&ensp;</sup>{promo}Xaf<span>/night</span></div>
    //     else
    //         return <div className="knsl-price">{price}Xaf<span>/night</span></div>
    // }

    function dishItem(dish:Dish) {
    
        return (
            <div key={dish.id}>
                <div className="knsl-menu-card">
                <div className="knsl-cover-frame">
                    <img src={dish.image} alt={t(`main.${dish.title}`) + ' - ' + t(`main.restaurant `) + ' ' + t(`main.siteName `)} />
                        {showBadge(dish.badge)}
                </div>
                <div className="knsl-description-frame">
                    <h3 className="knsl-mb-20">{t(`main.${dish.title}`)}</h3>
                    <div className=" knsl-text-sm knsl-mb-20">{t(`main.${dish.description}`)}</div>
                    <div className="knsl-card-bottom">
                        {/* {showPrice(dish.price, dish.promo)} */}
                    </div>
                </div>
                </div>
            </div>
        )
    }

    const banner =  {
        title : t('main.ourAwesomeMenu'),
        description : t('main.ourAwesomeMenuDesc'),
        navigation : [{path: '/restaurant', title: t('main.restaurant')}]    
    }

    const [filter, setFilter] = useState({page: 0, key: ''})
    
    let filteredDishes = dishes.filter(dish => dish.category.includes(filter.key))
    
    let pages = Math.trunc(filteredDishes.length/20)+1
    let renderDishes =filteredDishes.slice(filter.page*20, (filter.page+1)*20)

    function pageItem(index:number, ) {
        return <li key={index} className={filter.page===index?"knsl-active":""}><a href="#." onClick={() => setFilter({page:index, key: filter.key})}>{index+1}</a></li>
    }

    let pagesList : number[]
    pagesList = []
    for (let i = 0; i < pages; i++) {
        pagesList.push(i)
    }
    

    return(
        <>
            <Banner data={banner} />

            <section className="knsl-p-100-100">
                <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
                <div className="container">
                    
                    <div className="knsl-filter knsl-mb-60">
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: ''})} className={filter.key===''?"knsl-work-category knsl-current":"knsl-work-category"}>{t('main.AllCategories')}</span>
                        {/* <span style={cursorPointer} onClick={evt => setFilter({page:0, key: 'salad'})} className={filter.key==='salad'?"knsl-work-category knsl-current":"knsl-work-category"}>Salads</span> */}
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: 'main-course'})} className={filter.key==='main-course'?"knsl-work-category knsl-current":"knsl-work-category"}>{t('main.grills')}</span>
                        <span style={cursorPointer} onClick={evt => setFilter({page:0, key: 'drink'})} className={filter.key==='drink'?"knsl-work-category knsl-current":"knsl-work-category"}>{t('main.drinks')}</span>
                    </div>

                    <Masonry
                        breakpointCols={4}
                        className="knsl-masonry-grid"
                        columnClassName="knsl-masonry-grid-item">
                        {renderDishes.map(dish => dishItem(dish))}
                    </Masonry>
                    <ul className="knsl-pagination">
                        {pagesList.map(index => pageItem(index))}
                    </ul>
                </div>
            </section>
        </>
    )
}

export default Restaurant as React.FC